import esperantoFacila1 from './esperanto_facila_1';
import esperantoFacila2 from './esperanto_facila_2';
import esperantoKajNaturo from './esperanto_kaj_naturo';
import fiodoraDemokratio from './fiodora_demokratio';
import esperantoKajMi from './kion_eo_donis_al_mi';
import priLingvoPoezia from './pri_lingvo_poezia';
import priHerbradikaAgado2008 from './pri_herbradika_agado_2008';
import revolucioDeZombioj from './revolucio_de_zombioj';
import freŝaAeroMankas from './aero_mankas';
import iomPriLaGramatiko from './iom_pri_la_gramatiko';
import iomPriEkologio from './iom_pri_nuntempa_ekologio';
import kiamaniereKreskigiKlubon from './kiamaniere_kreskigi_klubon';
import iom_pri_ortodoksa_pasko from './iom_pri_ortodoksa_pasko';
import pri_izomorfismo from './pri_izomorfismo';
import mia_plej_bela_es_rememoro from './mia_plej_bela_es_rememoro';

const list = [
	esperantoFacila1,
	esperantoFacila2,
	esperantoKajNaturo,
	iomPriLaGramatiko,
	iomPriEkologio,
	kiamaniereKreskigiKlubon,
	esperantoKajMi,
	priLingvoPoezia,
	priHerbradikaAgado2008,
	revolucioDeZombioj,
	fiodoraDemokratio,
	freŝaAeroMankas,
	iom_pri_ortodoksa_pasko,
	pri_izomorfismo,
	mia_plej_bela_es_rememoro
];

export default list;